import { render, staticRenderFns } from "./RecoverPass.vue?vue&type=template&id=86fc2a58&lang=pug&"
import script from "./RecoverPass.vue?vue&type=script&lang=js&"
export * from "./RecoverPass.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPass.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports